import { FormProvider, useForm } from 'react-hook-form';

import styles from './CompanyQuestionAI.module.css';

type TCompanyQuestionAIData = {
  answer: string;
  sicCode: string;
};

const CompanyQuestionAI = () => {
  const methods = useForm<TCompanyQuestionAIData>();

  const { handleSubmit } = methods;

  // TODO: normalise company information (mainly for SIC Code)

  const onSubmit = async () => {
    // TODO: Tracking amplitude page needed - leaving this here as an example
    // TODO: Page navigation logic
  };

  return (
    <>
      <div className={styles.container}>
        <h2>Company Question AI Page</h2>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <div className={styles.formFieldContainer}>
              <div className={styles.formField}>
                {/* TODO: Add form field component for dynamic ai question here */}
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default CompanyQuestionAI;
